import { reactive } from 'vue';

export const unreadMessagesStore = reactive({
  count: 0,
  setCount(count) {
    this.count = count;
  },
});
